module.exports = __webpack_public_path__ + "static/media/Stackers-mb-en.a19cb503.jpg";